  document.addEventListener("DOMContentLoaded", function() {

    
    // Data for size comparison
    const sizeComparisonData = {
      0: { aus: 6, usa: 2, uk: 6, fra: 34, nz: 6 },
      1: { aus: 8, usa: 4, uk: 8, fra: 36, nz: 8 },
      2: { aus: 10, usa: 6, uk: 10, fra: 38, nz: 10 },
      3: { aus: 12, usa: 8, uk: 12, fra: 40, nz: 12 },
      4: { aus: 14, usa: 10, uk: 14, fra: 42, nz: 14 }
    };

// Function to update the size comparison table
function updateSizeComparisonTable(selectedSize) {
  const data = sizeComparisonData[selectedSize];
  
  if (data) {
    const natalieSizeElement = document.getElementById("natalie-size");
    if (natalieSizeElement) natalieSizeElement.innerText = selectedSize;

    const ausSizeElement = document.getElementById("aus-size");
    if (ausSizeElement) ausSizeElement.innerText = data.aus;

    const usaSizeElement = document.getElementById("usa-size");
    if (usaSizeElement) usaSizeElement.innerText = data.usa;

    const ukSizeElement = document.getElementById("uk-size");
    if (ukSizeElement) ukSizeElement.innerText = data.uk;

    const fraSizeElement = document.getElementById("fra-size");
    if (fraSizeElement) fraSizeElement.innerText = data.fra;

    const nzSizeElement = document.getElementById("nz-size");
    if (nzSizeElement) nzSizeElement.innerText = data.nz;
  }
}
    // Initialize the table on page load with the default size
    updateSizeComparisonTable(0);

    // Event listener for size change
    document.querySelectorAll('input[name="size"]').forEach(function(sizeRadio) {
      sizeRadio.addEventListener("change", function() {
        let selectedSize = this.value;
        updateSizeComparisonTable(selectedSize);
      });
    });

    // Function to convert cm to inches
    const CM_TO_INCH_FACTOR = 0.393701;
    function convertToInches(cm) {
      return (cm * CM_TO_INCH_FACTOR).toFixed(1).replace(/\.0$/, '');
    }

    // Function to clean and split the string into an array
    function extractData(dataString) {
      return dataString.replace(/[`"&quot;\[\]]/g, "").split(",");
    }

    // Event listener for unit change (CM to INCH)
    document.querySelectorAll('input[name="unit"]').forEach(function(unitRadio) {
      unitRadio.addEventListener("change", function() {
        let unit = this.value;
        updateMeasurementTable(unit);
      });
    });

    // Event listener for size change
    document.querySelectorAll('input[name="size"]').forEach(function(sizeRadio) {
      sizeRadio.addEventListener("change", function() {
        let selectedUnit = document.querySelector('input[name="unit"]:checked').value;
        updateMeasurementTable(selectedUnit);
      });
    });

// Function to update the measurement table based on the unit and size
function updateMeasurementTable(unit) {
  // Get the selected size
  let selectedSizeElement = document.querySelector('input[name="size"]:checked');
  let selectedSize = selectedSizeElement ? selectedSizeElement.value : null;

  if (selectedSize) {
    // Get the data from the data attributes and extract them
    let wrapper = document.querySelector(".size-guide-wrapper");
    if (wrapper) {
      let bustValues = extractData(wrapper.getAttribute("data-bust"));
      let waistValues = extractData(wrapper.getAttribute("data-waist"));
      let hipsValues = extractData(wrapper.getAttribute("data-hips"));
      let lengthAValues = extractData(wrapper.getAttribute("data-length-a"));
      let lengthBValues = extractData(wrapper.getAttribute("data-length-b"));

      // Set the values based on size and unit, with unit display
      const unitLabel = unit === "inch" ? " IN" : " CM";

      const bustValueElement = document.getElementById("bust-value");
      if (bustValueElement) {
        bustValueElement.innerText = (unit === "inch" ? convertToInches(bustValues[selectedSize]) : bustValues[selectedSize].replace(/\.0$/, '')) + unitLabel;
      }

      const waistValueElement = document.getElementById("waist-value");
      if (waistValueElement) {
        waistValueElement.innerText = (unit === "inch" ? convertToInches(waistValues[selectedSize]) : waistValues[selectedSize].replace(/\.0$/, '')) + unitLabel;
      }

      const hipsValueElement = document.getElementById("hips-value");
      if (hipsValueElement) {
        hipsValueElement.innerText = (unit === "inch" ? convertToInches(hipsValues[selectedSize]) : hipsValues[selectedSize].replace(/\.0$/, '')) + unitLabel;
      }

      const lengthAValueElement = document.getElementById("length-a-value");
      if (lengthAValueElement) {
        lengthAValueElement.innerText = (unit === "inch" ? convertToInches(lengthAValues[selectedSize]) : lengthAValues[selectedSize].replace(/\.0$/, '')) + unitLabel;
      }

      const lengthBValueElement = document.getElementById("length-b-value");
      if (lengthBValueElement) {
        lengthBValueElement.innerText = (unit === "inch" ? convertToInches(lengthBValues[selectedSize]) : lengthBValues[selectedSize].replace(/\.0$/, '')) + unitLabel;
      }
    }
  }
}


    // Initialize the measurement table on page load with CM as the default unit
    updateMeasurementTable("cm");

const sizeGuideButton = document.querySelector(".size-guide-button");
    if(sizeGuideButton){
// Functionality for opening and closing the size guide drawer
sizeGuideButton.addEventListener("click", function() {
  const drawer = document.querySelector(".size-guide-wrapper");
  const productTemplate = document.querySelector(".template-product");
  
  drawer.classList.toggle("active"); // Toggle the active class to slide in/out

  // Add or remove new class to/from .template-product based on drawer state
  if (drawer.classList.contains("active")) {
    productTemplate.classList.add("size-guide-active");
  } else {
    productTemplate.classList.remove("size-guide-active");
  }
});
    
const closeButton = document.querySelector(".close svg");
closeButton.addEventListener("click", function() {
  const drawer = document.querySelector(".size-guide-wrapper");
  const productTemplate = document.querySelector(".template-product");

  drawer.classList.remove("active"); // Close the drawer
  productTemplate.classList.remove("size-guide-active"); // Remove class from .template-product
});

// Close the drawer when clicking outside of it
document.addEventListener("click", function(event) {
  const drawer = document.querySelector(".size-guide-wrapper");
  const button = document.querySelector(".size-guide-button");
  const productTemplate = document.querySelector(".template-product");

  // Check if the click is outside the drawer and button
  if (!drawer.contains(event.target) && !button.contains(event.target)) {
    drawer.classList.remove("active"); // Close the drawer
    productTemplate.classList.remove("size-guide-active"); // Remove class from .template-product
  }
});
    }
  });


document.addEventListener('DOMContentLoaded', function() {
  function setDispatchDate(elementSelector, targetSelector, additionalDaysStart, additionalDaysEnd) {
    const element = document.querySelector(elementSelector);
    if (element) {
      const targetElement = element.querySelector(targetSelector) || document.querySelector(targetSelector);
      if (targetElement) {
        const startDate = calculateNextWeekday(new Date(), additionalDaysStart);
        const endDate = calculateNextWeekday(new Date(), additionalDaysEnd);

        const options = { month: 'long', day: 'numeric' };
        targetElement.textContent = `${startDate.toLocaleDateString(undefined, options)} - ${endDate.toLocaleDateString(undefined, options)}`;
      }
    }
  }

  function setSingleDispatchDate(elementSelector, targetSelector, additionalDays) {
    const element = document.querySelector(elementSelector);
    if (element) {
      const targetElement = element.querySelector(targetSelector) || document.querySelector(targetSelector);
      if (targetElement) {
        const date = calculateNextWeekday(new Date(), additionalDays);

        const options = { month: 'long', day: 'numeric' };
        targetElement.textContent = date.toLocaleDateString(undefined, options);
      }
    }
  }

function setSingleDispatchDate(elementSelector, targetSelector, additionalDays) {
  const element = document.querySelector(elementSelector);
  if (element) {
    const targetElement = element.querySelector(targetSelector) || document.querySelector(targetSelector);
    if (targetElement) {
      const date = calculateNextWeekday(new Date(), additionalDays);

      const options = { month: 'long', day: 'numeric' };
      const formattedDate = date.toLocaleDateString(undefined, options);

      targetElement.textContent = formattedDate;

      // Set hidden input value to send to cart
      const dispatchInput = document.querySelector('#dispatch-date-input');
      if (dispatchInput) {
        dispatchInput.value = formattedDate;
      }
    }
  }
}

  function calculateNextWeekday(currentDate, additionalDays) {
    const date = new Date(currentDate);
    date.setDate(date.getDate() + additionalDays);

    // If date falls on Saturday (6) or Sunday (0), adjust to next Monday
    if (date.getDay() === 6) {
      // If Saturday, add 2 days
      date.setDate(date.getDate() + 2);
    } else if (date.getDay() === 0) {
      // If Sunday, add 1 day
      date.setDate(date.getDate() + 1);
    }

    return date;
  }

  // Get the element by ID
  const dispatchDateElement = document.querySelector('#dispatch-date');
  
// Check if the element exists and get the data-date attribute
let madeToOrder = 28; // Default value
if (dispatchDateElement) {
  const dataDate = dispatchDateElement.getAttribute('data-date');
  madeToOrder = dataDate ? parseInt(dataDate, 10) : 28; // Fallback to 28 if data-date is invalid
  console.log('Made-to-Order Date:', madeToOrder);
} else {
  console.error('#dispatch-date element not found, using default value:', madeToOrder);
}

  // Set dispatch date for made-to-order items (20 to 28 days range)
  setSingleDispatchDate('.made-to-order', '#dispatch-date', madeToOrder);
  // Set dispatch date for made-to-order items (20 to 28 days range)
  setSingleDispatchDate('.made-to-order', '#dispatch-date_mobile', madeToOrder);

  // Set dispatch date for ready-to-wear items (single value, 1 day)
  setSingleDispatchDate('.ready-to-wear', '#dispatch-date-rtw', 1);
  // Set dispatch date for ready-to-wear items (single value, 1 day)
  setSingleDispatchDate('.ready-to-wear', '#dispatch-date-rtw_mobile', 1);
});



// Function to update displayed images based on the selected variant
function updateGalleryForSelectedVariant(selectedValue, originalValue) {
  // Find all images with the matching data-value in the PhotoSwipe gallery
  let matchingImages = document.querySelectorAll(`.photoswipe-gallery [data-value="${selectedValue}"]`);

  const colorUnavailableElement = document.querySelector('.colorUnavailable');
  const colorInfoElement = document.querySelector('.is_color_info');

  // Handle the case where there are no matching images for the selected variant
  if (matchingImages.length === 0) {
    // Get the first variant data-value
    const firstVariantInput = document.querySelector('.variant-input-wrap[name="Color"] .variant-input');
    
    if (firstVariantInput) {
      const firstVariantValue = firstVariantInput.getAttribute('data-value').toLowerCase().replace(/\s+/g, '');

      // Find images with the data-value of the first variant
      matchingImages = document.querySelectorAll(`.photoswipe-gallery [data-value="${firstVariantValue}"]`);
    }

    // Display the color unavailable message
    if (colorUnavailableElement) {
      if (colorUnavailableElement.dataset.silk === 'true') {
        colorUnavailableElement.innerHTML = `<a href="/blogs/beauty/silk" target="_blank">View Colour References ></a>`;
      } else {
        colorUnavailableElement.textContent = `${originalValue} - Image Unavailable. Showing default variant images.`;
      }
      colorUnavailableElement.style.display = 'block';
    }

    // Append "- Image Unavailable" span to .is_color_info element
    if (colorInfoElement) {
      let unavailableSpan = colorInfoElement.querySelector('.unavailable-span');
      if (!unavailableSpan) {
        unavailableSpan = document.createElement('span');
        unavailableSpan.classList.add('unavailable-span');
        if (colorUnavailableElement.dataset.silk === 'true') {
        unavailableSpan.innerHTML = ` - Image Unavailable`;
        } else {
        unavailableSpan.textContent = ' - Image Unavailable';
        }
        colorInfoElement.appendChild(unavailableSpan);
      }
    }
  } else {
    // If matching images are found, hide the color unavailable message
    if (colorUnavailableElement) {
      colorUnavailableElement.style.display = 'none';
    }

    // Remove "- Image Unavailable" span from .is_color_info element if present
    if (colorInfoElement) {
      const unavailableSpan = colorInfoElement.querySelector('.unavailable-span');
      if (unavailableSpan) {
        unavailableSpan.remove();
      }
    }
  }

  // Hide all images and show only the matching images
  document.querySelectorAll('.photoswipe-gallery > *').forEach(image => {
    if(window.innerWidth > 949) {
    image.style.display = Array.from(matchingImages).includes(image) ? 'block' : 'none';
    } else {
      image.style.display = Array.from(matchingImages).includes(image) ? 'flex' : 'none';
    }
  });

  // Scroll to the first matching image
  /*if ( window.innerWidth > 949 && matchingImages[0]) {
    matchingImages[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }*/
}

// Event listener for variant input clicks
document.querySelectorAll('.variant-input-wrap[name="Color"] .variant-input').forEach(inputWrap => {
  inputWrap.addEventListener('click', function () {
    // Get the selected variant value, convert to lowercase, and remove spaces
    const originalValue = inputWrap.getAttribute('data-value');
    const selectedValue = originalValue.toLowerCase().replace(/\s+/g, '');

    // Update the gallery based on the selected variant
    updateGalleryForSelectedVariant(selectedValue, originalValue);
  });
});

// Run the script on page load to handle pre-selected variant
document.addEventListener('DOMContentLoaded', function () {
  const checkedInput = document.querySelector('.variant-input-wrap[name="Color"] .variant-input input[type="radio"]:checked');

  if (checkedInput) {
    const originalValue = checkedInput.value;
    const selectedValue = originalValue.toLowerCase().replace(/\s+/g, '');

    // Update the gallery based on the selected variant
    updateGalleryForSelectedVariant(selectedValue, originalValue);
  }
});



document.addEventListener('DOMContentLoaded', function() {
  // Select both the Size and Color radio inputs
  var variantRadios = document.querySelectorAll('input[name="Size"], input[name="Color"]');

  // Listen for change events on these radio inputs
  variantRadios.forEach(function(radio) {
    radio.addEventListener('change', updateVariantSelection);
  });

  function updateVariantSelection() {
    // Get the currently checked values for Size and Color
    var selectedSize = document.querySelector('input[name="Size"]:checked').value;
    var selectedColor = document.querySelector('input[name="Color"]:checked').value;

    // Build the search key (e.g., "4 / Lemon")
    var searchKey = selectedSize + " / " + selectedColor;

    // Get the main product <select> element that holds all variant options
    var selectEl = document.querySelector('.product-single__variants');
    var isAvailable = false;

    // Loop through the main <select> options to find the matching variant
    for (var i = 0; i < selectEl.options.length; i++) {
      var optionText = selectEl.options[i].textContent.trim();

      // If the variant text starts with "Size / Color"
      if (optionText.indexOf(searchKey) === 0) {
        // Set the selected index for the main product <select>
        selectEl.selectedIndex = i;

        // Update the product price element using the data-price attribute
        var newPriceHTML = selectEl.options[i].getAttribute('data-price');
        document.querySelector('.title_price_wrapper .product__price').innerHTML = newPriceHTML;

        // Determine if the variant is available (disabled means sold out)
        isAvailable = !selectEl.options[i].disabled;
        console.log("Variant is available:", isAvailable);

        // Also update the modal's <select> if it exists
        var modalSelect = document.getElementById("variants");
        if (modalSelect) {
          for (var j = 0; j < modalSelect.options.length; j++) {
            var modalOptionText = modalSelect.options[j].textContent.trim();
            if (modalOptionText.indexOf(searchKey) === 0) {
              modalSelect.selectedIndex = j;
              break;
            }
          }
        }

        // Break once the matching option is found
        break;
      }
    }

    // --- Add-to-Cart / BIS button toggle logic ---
     const bisBtn = document.querySelector('#BIS_trigger');

  function toggleButtons() {
    const addToCartBtn = document.querySelector('.add-to-cart:not(#BIS_trigger)');
    const available = typeof isAvailable !== 'undefined' ? isAvailable : true;

    console.log('[Toggle] BIS button found:', !!bisBtn);
    console.log('[Toggle] Add-to-Cart button found:', !!addToCartBtn);
    console.log('[Toggle] Product availability:', available);

    if (!addToCartBtn) {
      console.warn('[Toggle] No .add-to-cart button found in DOM.');
      return;
    }

    const addToCartText = addToCartBtn.querySelector('span');
    console.log('[Toggle] Add-to-Cart text element found:', !!addToCartText);

    if (bisBtn) {
      if (!available) {
        addToCartBtn.classList.add('disabled');
        bisBtn.classList.remove('disabled');
        console.log('[Toggle] Showing BIS button, disabling Add-to-Cart.');
      } else {
        addToCartBtn.classList.remove('disabled');
        bisBtn.classList.add('disabled');
        console.log('[Toggle] Hiding BIS button, enabling Add-to-Cart.');
      }
    } else {
      if (!available) {
        addToCartBtn.classList.add('disabled');
        if (addToCartText) {
          addToCartText.textContent = 'SOLD OUT';
          console.log('[Toggle] Product unavailable. Set button text to SOLD OUT.');
        }
      } else {
        addToCartBtn.classList.remove('disabled');
        if (addToCartText) {
          const defaultText = addToCartText.getAttribute('data-default-text') || 'ADD TO CART';
          addToCartText.textContent = defaultText;
          console.log('[Toggle] Product available. Reset button text to:', defaultText);
        }
      }
    }
  }

  function waitForButtonAndToggle(maxRetries = 20) {
    let retries = 0;
    const interval = setInterval(() => {
      const btn = document.querySelector('.add-to-cart:not(#BIS_trigger)');
      if (btn || retries >= maxRetries) {
        clearInterval(interval);
        toggleButtons(); // Safe to call; includes null check
      } else {
        console.log(`[Retry] Attempt ${retries + 1}: .add-to-cart not found yet`);
        retries++;
      }
    }, 100); // Check every 100ms (2s max)
  }

  waitForButtonAndToggle();

    //  New step: Toggle .disabled on Size labels based on availability
    toggleSizeLabels(selectedColor);
  }

  /**
   * Loop through each Size input/label and see if
   * "Size / selectedColor" is available. If not, add .disabled
   * to its label. Otherwise, remove .disabled.
   */
  function toggleSizeLabels(selectedColor) {
    var selectEl = document.querySelector('.product-single__variants');
    var sizeRadios = document.querySelectorAll('input[name="Size"]');

    sizeRadios.forEach(function(radio) {
      var sizeValue = radio.value;
      var labelEl = document.querySelector('label[for="' + radio.id + '"]');
      if (!labelEl) return; // safety check

      // Build the text we expect in the <option> (e.g., "4 / Espresso")
      var comboText = sizeValue + " / " + selectedColor;
      var isComboAvailable = false;

      // Check all <option> elements to see if "comboText" is found and not disabled
      for (var i = 0; i < selectEl.options.length; i++) {
        var optText = selectEl.options[i].textContent.trim();
        if (optText.indexOf(comboText) === 0 && !selectEl.options[i].disabled) {
          isComboAvailable = true; // found a matching enabled variant
          break;
        }
      }

      // Toggle the .disabled class on the label based on availability
      if (!isComboAvailable) {
        labelEl.classList.add('disabled');
      } else {
        labelEl.classList.remove('disabled');
      }
    });
  }

}); // end DOMContentLoaded

document.addEventListener("DOMContentLoaded", function () {
  setTimeout(() => {
    const buttons = document.querySelectorAll('.add-to-cart');
    if (buttons.length === 0) return;

    const observer = new MutationObserver(function (mutationsList) {
      for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
          mutation.target.removeAttribute('style');
        }
      }
    });

    buttons.forEach(button => {
      if (button.hasAttribute('style')) {
        button.removeAttribute('style');
      }
      observer.observe(button, { attributes: true });
    });
  }, 100); // 100ms delay helps Safari
});

